/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { SupplierPageComponent } from "@src/app/modules/supply/supplier-page/supplier-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const SupplierPageNavRoute = new NavRoute('suppliers', ()=>SupplierPageComponent, 'shopping_cart').setViews(() => [{
    id: 'agencySuppliers',
    name: 'All Agency Suppliers',
    helpText: 'All suppliers registered at agency level',
    filterFields: {
        name: null,
        omcTeamId: 'NULL'
    }
},{
    id: 'omcSuppliers',
    name: 'All OMC Specific Suppliers',
    helpText: 'All suppliers specific to an OMC',
    filterFields: {
        name: null,
        omcTeamId: 'NOT NULL'
    }
},{
    id: 'allSuppliers',
    name: 'All Suppliers',
    helpText: 'All suppliers at agent level or specific to an OMC',
    filterFields: {
        name: null,
    }
}]);
